import {sleep} from './sleep.js'; 

export default class VideoFileToStream {
  constructor(fileOrBlob, videoElement){
    this._file = fileOrBlob;
    this._videoElement = videoElement;
    this._init = this._init.bind(this);
    this._capturedStream = undefined;

    this.play = this.play.bind(this);
    this.close = this.close.bind(this);
    this.getVideoStream = this.getVideoStream.bind(this);
    this._init();
  }

  _init(){
    if (this._file.constructor.name === 'File') {
      console.log('VideoFileToStream() input file');
    } else if (this._file.constructor.name === 'Blob') {
      console.log('VideoFileToStream() input Blob');
    } else return;

    this._videoElement.pause();
    this._videoElement.srcObject = null;
    this._videoElement.src = URL.createObjectURL(this._file);
    this._videoElement.load();

    this._videoElement.oncanplaythrough = (e) => {
      if (this._videoElement.captureStream) {
        this._capturedStream 
         = this._videoElement.captureStream(); // Chrome etc.
      } else if (this._videoElement.mozCaptureStream){
        this._capturedStream 
          = this._videoElement.mozCaptureStream(); // Firefox
        const audioCtx = new AudioContext(); 
        const source = audioCtx.createMediaStreamSource(this._capturedStream);
        source.connect(audioCtx.destination);
      } else {
        console.error('Sorry captureStream() is NOT available on this browser',
          navigator.userAgent);
      }
    };

  }

  async play(){
    this._videoElement.start();
  }

  close(){
    this._videoElement.pause();
  }

  async getVideoStream(){
    while (!this._capturedStream) await sleep(100);
    return this._capturedStream;
  }

}
